import { render, staticRenderFns } from "./subscriptions.vue?vue&type=template&id=1503b782&scoped=true&"
import script from "./subscriptions.vue?vue&type=script&lang=js&"
export * from "./subscriptions.vue?vue&type=script&lang=js&"
import style0 from "./subscriptions.vue?vue&type=style&index=0&id=1503b782&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1503b782",
  null
  
)

export default component.exports